import '../styles/components/Achievements.css';
import { m } from 'framer-motion';
import { fadeUp, staggerContainer, staggerItem, viewport } from '../motion/variants';

const stats = [
  { value: '100+', label: 'Successful Deliveries' },
  { value: '50+', label: 'Construction Projects Supported' },
  { value: '5+', label: 'Years of Industry Experience' },
  { value: '24/7', label: 'Customer Support' },
];

function Achievements() {
  return (
    <section className="achievements" id="achievements" aria-labelledby="achievements-heading">
      <div className="achievements-inner">
        <m.header
          className="achievements-header"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={fadeUp}
        >
          <h2 id="achievements-heading">Our Achievements</h2>
        </m.header>

        <m.ul
          className="achievements-stats"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={staggerContainer}
        >
          {stats.map((stat) => (
            <m.li className="achievements-stat" key={stat.label} variants={staggerItem}>
              <span className="achievements-value">{stat.value}</span>
              <span className="achievements-label">{stat.label}</span>
            </m.li>
          ))}
        </m.ul>
      </div>
    </section>
  );
}

export default Achievements;
